import React from "react";
import i18n from "../../../../locale/i18n";
import PriceUpDown from "../../../../components/ui/PriceUpDown";
import { PRICE_STATUS, POSITIVE_CHANGE_NUMBER_FORMAT } from "../../../../constant/common";
import { useCompanySettings } from "../../../../hooks/useCompanySettings";
import { getCurrencyLabel } from "../../../../store/utils";

const QuadrataAverageBasedCalculatorResults = ({ results, formatNumber, currency }) => {
    const companySettings = useCompanySettings();
    if (!results) {
        return null;
    }

    const currencyLabel = results.currency ? getCurrencyLabel(results.currency) : "";
    const positiveChangeFormat =
        companySettings.format?.positiveChangeFormat || POSITIVE_CHANGE_NUMBER_FORMAT;

    const isChangePositive = results.change >= 0;

    return (
        <div className="average-based-calculator-results template-quadrata">
            <div
                className={`average-based-calculator-results__box ${isChangePositive
                    ? "average-based-calculator-results__box--positive"
                    : "average-based-calculator-results__box--negative"
                    }`}
            >
                <div className="average-based-calculator-results__last-price-box">
                    <div className="average-based-calculator-results__label">
                        {i18n.translate("lastPrice")}:
                    </div>
                    <div className="average-based-calculator-results__value">
                        {currencyLabel ? `${currencyLabel} ` : ""}{formatNumber(results.lastPrice)}
                    </div>
                </div>

                <div className="average-based-calculator-results__metrics-grid">
                    <div className="average-based-calculator-results__item">
                        <div className="average-based-calculator-results__label">
                            {i18n.translate("totalAmountInvested")} {currencyLabel ? `(${currencyLabel})` : ""}
                        </div>
                        <div className="average-based-calculator-results__value average-based-calculator-results__value--total-amount">
                            {formatNumber(results.totalAmountInvested)}
                        </div>
                    </div>

                    <div className="average-based-calculator-results__item">
                        <div className="average-based-calculator-results__label">
                            {i18n.translate("currentValue")} {currencyLabel ? `(${currencyLabel})` : ""}
                        </div>
                        <div
                            className={`average-based-calculator-results__value ${isChangePositive
                                ? "average-based-calculator-results__value--positive"
                                : "average-based-calculator-results__value--negative"
                                }`}
                        >
                            {formatNumber(results.currentValue)}
                        </div>
                    </div>

                    <div className="average-based-calculator-results__item">
                        <div className="average-based-calculator-results__label">
                            {i18n.translate("changePercentage")}
                        </div>
                        <div
                            className={`average-based-calculator-results__value ${isChangePositive
                                ? "average-based-calculator-results__value--positive"
                                : "average-based-calculator-results__value--negative"
                                }`}
                        >
                            <PriceUpDown
                                status={results.change >= 0 ? PRICE_STATUS.UP : PRICE_STATUS.DOWN}
                            >
                                <span>
                                    {formatNumber(Math.abs(results.change))}{" "}
                                    ({formatNumber(results.changePercentage, {
                                        positiveFormatPattern: positiveChangeFormat,
                                    })}
                                    %)
                                </span>
                            </PriceUpDown>
                        </div>
                    </div>
                </div>
            </div>

            <div className="average-based-calculator-results__note">
                <strong>{i18n.translate("note")}:</strong>{" "}
                {i18n.translate("averageBasedCalculatorNote")}
            </div>
        </div>
    );
};

export default QuadrataAverageBasedCalculatorResults;

